import { throwError as observableThrowError, Observable } from 'rxjs'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { TempidcardGateway } from '../gateways/tempID-gateway'

@Injectable()
export class NetworktempidcardGateway implements TempidcardGateway {
    constructor(private http: HttpClient) {}

    public handleError = (error: Response) => {
        // Do messaging and error handling here
        return observableThrowError(error)
    }

    DownloadPDF(ParentName: string, SectionName: string): Observable<any> {
        var downloadData = this.http.get<any>('../api/content/DownloadPDF/' + ParentName + '/' + SectionName)
        return downloadData
    }

    streamPDF(parent: string, section: string): Observable<any> {
        return this.http.get('../api/content/streampdf/' + parent + '/' + section, {
            headers: new HttpHeaders().set('Content-Type', 'application/pdf'),
            responseType: 'blob',
            observe: 'body'
        })
    }
}
